import { InformationCircleIcon } from '@heroicons/react/24/outline';

import { Input } from '@/components/form/Input';
import { Tooltip } from '@/components/Tooltip';
import { Container } from '@/components/ui';
import { SUBSCRIPTION_INPUT_CLASS } from '@/sections/settings/subscription/constant';
import { cn } from '@/utils/classname';

export interface UsagePriceSectionProps {
  actualTotalAssets: number;
  actualTotalApplications: number;
  usagePrice: number;
  usageFloor: number;
  inputClassName?: string;
}

export function UsagePriceSection({
  actualTotalAssets,
  actualTotalApplications,
  usagePrice,
  usageFloor,
}: UsagePriceSectionProps) {
  return (
    <section className="space-y-4">
      <h3 className="text-chariot-text-primary text-base font-semibold">
        Usage Price
      </h3>
      <Container className="bg-chariot-background-primary">
        {/* Current Usage (Read-only) */}
        <div className="mb-4 space-y-3">
          <div className="flex items-center justify-between">
            <label className="text-chariot-text-primary text-sm">
              Current Asset Usage
            </label>
            <Input
              name="currentAssets"
              value={actualTotalAssets.toLocaleString()}
              onChange={() => {}}
              disabled
              className={cn(
                SUBSCRIPTION_INPUT_CLASS,
                'w-32 cursor-not-allowed text-right opacity-60'
              )}
            />
          </div>

          <div className="flex items-center justify-between">
            <label className="text-chariot-text-primary text-sm">
              Current Application Usage
            </label>
            <Input
              name="currentApplications"
              value={actualTotalApplications.toLocaleString()}
              onChange={() => {}}
              disabled
              className={cn(
                SUBSCRIPTION_INPUT_CLASS,
                'w-32 cursor-not-allowed text-right opacity-60'
              )}
            />
          </div>
        </div>

        {/* Usage Price below */}
        <div className="border-chariot-stroke flex items-center justify-between border-t pt-4">
          <p className="text-chariot-text-tertiary flex items-center gap-2 text-xs font-semibold tracking-wide uppercase">
            Usage Price
            <Tooltip title="Auto-Calculated Based on Current Coverage">
              <InformationCircleIcon className="text-chariot-text-secondary h-4 w-4" />
            </Tooltip>
          </p>
          <div className="text-chariot-text-primary text-right">
            <div className="text-2xl font-bold">
              ${usagePrice.toLocaleString()}
            </div>
            <div className="text-chariot-text-secondary text-xs">
              Floor: ${usageFloor.toLocaleString()}
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
